import { createTheme, MantineColorsTuple } from "@mantine/core";

const brand: MantineColorsTuple = [
  "#eef5fa",
  "#d9e8f3",
  "#b3d0e6",
  "#8ab7d8",
  "#6aa0cb",
  "#5491c2",
  "#4682B4",
  "#3a6f9a",
  "#315d81",
  "#254560",
];

export const theme = createTheme({
  primaryColor: "brand",
  colors: {
    brand,
  },
  fontFamily:
    "Segoe UI, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  defaultRadius: "md",
});
